// extracted by mini-css-extract-plugin
var _1 = "QJHm8WoB";
var _2 = "QJHm8WoB";
var _3 = "WPRetFyP";
var _4 = "WPRetFyP";
var _5 = "Q3jbpEOf";
var _6 = "fZ0vhdZ0";
var _7 = "VuyZLMcH";
var _8 = "T8GHHOo0";
var _9 = "Kww_MAFu";
var _a = "Q3jbpEOf";
var _b = "fZ0vhdZ0";
var _c = "VuyZLMcH";
var _d = "T8GHHOo0";
var _e = "Kww_MAFu";
var _f = "Aktp_lLC";
var _10 = "Aktp_lLC";
var _11 = "qRLzz_IH";
var _12 = "qRLzz_IH";
export { _1 as "contact-info", _2 as "contactInfo", _3 as "extended-footer", _4 as "extendedFooter", _5 as "footer-button", _6 as "footer-contact", _7 as "footer-icon-link", _8 as "footer-items", _9 as "footer-opening-hours", _a as "footerButton", _b as "footerContact", _c as "footerIconLink", _d as "footerItems", _e as "footerOpeningHours", _f as "section-footer-contact", _10 as "sectionFooterContact", _11 as "social-media", _12 as "socialMedia" }
